import { ApiError, type ApiClient } from './client';

export interface CreateUploadInput {
  filename: string;
  mimeType: string;
  size: number;
}

export interface CreateUploadResult {
  key: string;
  uploadUrl: string;
  mimeType: string;
  expiresIn: number;
}

interface CreateUploadRaw {
  key: string;
  upload_url: string;
  mime_type: string;
  expires_in: number;
}

export async function createUpload(
  client: ApiClient,
  input: CreateUploadInput,
): Promise<CreateUploadResult> {
  const raw = await client.request<CreateUploadRaw>('/api/v1/uploads', {
    method: 'POST',
    json: {
      filename: input.filename,
      mime_type: input.mimeType,
      size: input.size,
    },
  });
  return {
    key: raw.key,
    uploadUrl: raw.upload_url,
    mimeType: raw.mime_type,
    expiresIn: raw.expires_in,
  };
}

export async function uploadFile(input: {
  uploadUrl: string;
  mimeType: string;
  file: Blob;
}): Promise<void> {
  let resp: Response;
  try {
    resp = await fetch(input.uploadUrl, {
      method: 'PUT',
      headers: { 'Content-Type': input.mimeType },
      body: input.file,
    });
  } catch (e) {
    throw new ApiError('network', e instanceof Error ? e.message : 'network error');
  }
  if (!resp.ok) {
    throw new ApiError('unknown', `upload failed: HTTP ${resp.status}`, resp.status);
  }
}
